import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Globe2, Save, ExternalLink } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CountryIntrosPanel = ({ authHeaders }) => {
  const [countries, setCountries] = useState([]);
  const [active, setActive] = useState(null);
  const [intro, setIntro] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/country-pages`, authHeaders).then((r) => {
      setCountries(r.data.countries);
      if (r.data.countries[0]) { setActive(r.data.countries[0].slug); setIntro(r.data.countries[0].intro); }
    }).catch(() => toast.error('Could not load country pages'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const current = countries.find((c) => c.slug === active);
  const pick = (c) => { setActive(c.slug); setIntro(c.intro); };

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/country-pages/${active}?country=${encodeURIComponent(current.country)}`, { intro }, authHeaders);
      setCountries(countries.map((c) => (c.slug === active ? { ...c, intro, customised: true } : c)));
      toast.success(`${current.country} introduction saved`);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not save');
    } finally { setSaving(false); }
  };

  return (
    <div className="bg-white rounded-2xl border border-[#E6DAC5] p-6" data-testid="country-intros-panel">
      <div className="flex items-center gap-2 mb-1"><Globe2 size={18} className="text-[#3B164C]" /><h3 className="font-semibold text-[#1E1622]">Country Pages</h3></div>
      <p className="text-sm text-[#1E1622]/60 mb-4">The introduction shown at the top of each Small Towns Series country page.</p>
      {countries.length === 0 ? <p className="text-sm text-[#1E1622]/50">No countries in the series yet.</p> : (
        <>
          <div className="flex flex-wrap gap-2 mb-4">
            {countries.map((c) => (
              <button key={c.slug} onClick={() => pick(c)} data-testid={`country-intro-tab-${c.slug}`}
                className={`px-4 py-1.5 rounded-full text-sm border transition-colors duration-200 ${active === c.slug ? 'bg-[#3B164C] text-white border-[#3B164C]' : 'border-[#E6DAC5] text-[#1E1622]/70 hover:border-[#3B164C]'}`}>
                {c.country}{!c.customised && <span className="ml-1 opacity-60">· starter</span>}
              </button>
            ))}
          </div>
          <textarea rows={6} value={intro} onChange={(e) => setIntro(e.target.value)} data-testid="country-intro-input"
            className="w-full p-3 border border-[#E6DAC5] rounded-xl focus:border-[#3B164C] focus:outline-none text-sm" />
          <div className="flex items-center justify-between mt-3">
            <a href={`/shop/countries/${active}`} target="_blank" rel="noreferrer" data-testid="country-intro-view-link" className="text-sm text-[#3B164C] inline-flex items-center gap-1 hover:text-[#C5A059]">View page <ExternalLink size={14} /></a>
            <button onClick={save} disabled={saving || !intro.trim()} data-testid="country-intro-save-btn" className="btn-primary text-sm inline-flex items-center gap-2 disabled:opacity-50"><Save size={16} /> {saving ? 'Saving…' : 'Save introduction'}</button>
          </div>
        </>
      )}
    </div>
  );
};
